import { render, staticRenderFns } from "./AutoLoginComponent.vue?vue&type=template&id=8b37f340"
import script from "./AutoLoginComponent.vue?vue&type=script&lang=js"
export * from "./AutoLoginComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports